import { useParams } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  Label,
  RadioGroup,
  RadioGroupItem,
} from '@accure/ui';

import { type AddTaskModalOpen, useAddTaskModal } from './add-task.provider';
import { CreateTaskForm } from './create-task.form';
import { LinkTaskForm } from './link-task.form';

export type AddTaskModalProps = {
  open: AddTaskModalOpen;
  onClose: () => void;
};

export function AddTaskModal({ open, onClose }: AddTaskModalProps) {
  const { siteId } = useParams<{ siteId: string }>();
  const addTask = useAddTaskModal();

  return (
    <Dialog open={Boolean(open)} onOpenChange={onClose}>
      <DialogContent className="gap-6 sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Add Task to Workstream</DialogTitle>
          <p className="text-sm text-gray-600">
            Add a task to the selected workstream to track progress and assign
            responsibilities.
          </p>
        </DialogHeader>

        <RadioGroup
          value={open?.formType}
          onValueChange={function (value) {
            if (open) {
              addTask({ ...open, formType: value as 'create' | 'link' });
            }
          }}
          className="flex flex-col gap-3"
        >
          <div className="flex items-center gap-2">
            <RadioGroupItem value="create" id="create" />
            <Label htmlFor="create" className="font-medium">
              Create New Task
            </Label>
          </div>
          <div className="flex items-center gap-2">
            <RadioGroupItem value="link" id="link" />
            <Label htmlFor="link" className="font-medium">
              Select Existing Task
            </Label>
          </div>
        </RadioGroup>

        {open?.formType === 'create' ? (
          <CreateTaskForm
            siteId={siteId}
            workstreamId={open.workstreamId}
            onClose={onClose}
          />
        ) : open?.formType === 'link' ? (
          <LinkTaskForm
            siteId={siteId}
            workstreamId={open.workstreamId}
            onClose={onClose}
          />
        ) : null}
      </DialogContent>
    </Dialog>
  );
}
